import { ISelectOption } from '@northladder/utilities';

import { IAssetGroupData } from '../types';

/**
 * This formats the raw brand data into the desired structure.
 */
export function formatAssetGroups(
  assetGroupsData: IAssetGroupData
): ISelectOption[] {
  return assetGroupsData.assetGroups?.map((brand) => {
    const { _id, name } = brand;
    return {
      value: _id,
      label: name,
      labelStr: name,
    };
  });
}
